module.exports = __webpack_public_path__ + "img/Card_back.svg.20d27921.png";